(function() {
  if (window.__pmoInit) return;
  window.__pmoInit = true;

  // The slider uses CSS transforms on its ancestors, which breaks
  // position:fixed (it becomes relative to the transformed ancestor
  // instead of the viewport). Moving the modal to <body> fixes this.
  var modal = document.querySelector('[data-pmo-modal]');
  if (modal && modal.parentElement !== document.body) {
    document.body.appendChild(modal);
  }

  function getDots() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-pmo-dot]'));
  }

  function getModal() {
    return document.querySelector('[data-pmo-modal]');
  }

  document.addEventListener('click', function(e) {
    var dot = e.target.closest('[data-pmo-dot]');
    if (dot) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      var dots = getDots();
      var index = dots.indexOf(dot);
      openModal(index);
      return;
    }

    var closeBtn = e.target.closest('[data-pmo-modal-close]');
    if (closeBtn) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      closeModal();
      return;
    }

    var prevBtn = e.target.closest('[data-pmo-prev]');
    if (prevBtn) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      stepModal(-1);
      return;
    }

    var nextBtn = e.target.closest('[data-pmo-next]');
    if (nextBtn) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      stepModal(1);
      return;
    }
  }, true);

  document.addEventListener('keydown', function(e) {
    var modal = getModal();
    if (!modal || !modal.classList.contains('is-open')) return;
    if (e.key === 'Escape') closeModal();
    if (e.key === 'ArrowLeft') stepModal(-1);
    if (e.key === 'ArrowRight') stepModal(1);
  });

  function openModal(index) {
    var modal = getModal();
    if (!modal) return;
    modal.dataset.pmoCurrent = index;
    renderModal(modal, index);
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('pmo-lock-scroll');
  }

  function closeModal() {
    var modal = getModal();
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('pmo-lock-scroll');
  }

  function stepModal(dir) {
    var modal = getModal();
    if (!modal) return;
    var dots = getDots();
    var current = parseInt(modal.dataset.pmoCurrent || '0', 10);
    var next = (current + dir + dots.length) % dots.length;
    modal.dataset.pmoCurrent = next;
    renderModal(modal, next);
  }

  function renderModal(modal, index) {
    var dots = getDots();
    var dot = dots[index];
    if (!dot) return;
    modal.querySelector('[data-pmo-modal-image]').src = dot.getAttribute('data-pmo-img');
    modal.querySelector('[data-pmo-modal-image]').alt = dot.getAttribute('data-pmo-title');
    modal.querySelector('[data-pmo-modal-title]').textContent = dot.getAttribute('data-pmo-title');
    modal.querySelector('[data-pmo-modal-desc]').textContent = dot.getAttribute('data-pmo-desc');
  }
})();
